import * as React from 'react';

import { useEventListener } from 'shared/entities/common/hooks';

import './Blurable.modules.scss';

type Props = {
  onBlur?: (e: Event) => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const BlurrableWrapper: React.FC<Props> = ({
  children,
  onBlur,
  className,
  style
}: Props) => {
  const container = React.useRef<HTMLDivElement>(null);

  const handlePointerDown = React.useCallback(
    (e: PointerEvent) => {
      if (e.target !== container.current) {
        return;
      }
      onBlur?.(e);
    },
    [onBlur]
  );

  useEventListener({
    eventName: 'pointerdown',
    getElement: () => container.current,
    handler: handlePointerDown
  });

  return (
    <div
      ref={container}
      style={style}
      styleName="blurable"
      className={className}
    >
      {children}
    </div>
  );
};

export default BlurrableWrapper;
